var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-icon": "container",
    fill: "currentColor",
    height: "1.1em",
    viewBox: "0 0 512 512",
    width: "1.1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m151 272h-60c-8.284 0-15 6.716-15 15s6.716 15 15 15h60c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m151 212h-60c-8.284 0-15 6.716-15 15s6.716 15 15 15h60c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m286 257c0 41.355 33.645 75 75 75s75-33.645 75-75-33.645-75-75-75-75 33.645-75 75zm120 0c0 24.813-20.187 45-45 45s-45-20.187-45-45 20.187-45 45-45 45 20.187 45 45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m414.358 399.845 47.292-52.874c22.151-24.764 34.35-56.717 34.35-89.971 0-69.369-52.594-126.676-120-134.162v-107.838c0-8.284-6.716-15-15-15h-330c-8.284 0-15 6.716-15 15v332c0 8.284 6.716 15 15 15h242.792l33.85 37.845c-32.053 10.244-51.642 29.393-51.642 52.155 0 34.206 45.141 60 105 60s105-25.794 105-60c0-22.762-19.589-41.911-51.642-52.155zm51.642-142.845c0 25.865-9.486 50.714-26.711 69.971l-78.289 87.529-78.289-87.529c-17.225-19.257-26.711-44.107-26.711-69.971 0-57.897 47.103-105 105-105s105 47.103 105 105zm-300-227h60v60h-60zm-120 0h90v75c0 8.284 6.716 15 15 15h90c8.284 0 15-6.716 15-15v-75h90v92.838c-67.406 7.486-120 64.793-120 134.162 0 26.889 7.979 52.925 22.743 75h-202.743zm315 452c-45.783 0-75-17.768-75-30 0-9.163 16.676-21.417 44.14-27.002l19.679 22.002c5.956 6.659 16.397 6.668 22.361 0l19.679-22.002c27.465 5.585 44.141 17.839 44.141 27.002 0 12.232-29.217 30-75 30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalmap);
export default __webpack_public_path__ + "static/media/digitalmap.d2eb6e0c.svg";
export { ForwardRef as ReactComponent };